import React, { useState } from "react"
import { storefrontPopupComponentDefaultDataMap } from "./storefrontPopupBlocksData";

// export const desktopSVG = "<svg viewBox='0 0 2048 1792' xmlns='http://www.w3.org/2000/svg'><path d='M1856 992v-832q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zm128-832v1088q0 66-47 113t-113 47h-544q0 37 16 77.5t32 71 16 43.5q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45q0-14 16-44t32-70 16-78h-544q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1600q66 0 113 47t47 113z' class='cc-devices-svg-icon'/></svg>";
// export const largeTabletSVG = "<svg viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'><path d='M2 2c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm2 0v14h12V2H4zm6 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' class='cc-devices-svg-icon'/></svg>";
// export const smallTabletSVG = "<svg enable-background='new 0 0 48 48' height='48px' id='Layer_3' version='1.1' viewBox='0 0 48 48' width='48px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><path d='M41.25,0H39h-6.125h-1.188h-14.25h-2.562H9H7H5v48h2h2h5.875h1.375h15.062h1.562H39h1.438H43V34.375v-2.438  V15v-2V0H41.25z M24,43.959c-1.104,0-2-0.896-2-2s0.896-2,2-2c1.105,0,2,0.896,2,2S25.105,43.959,24,43.959z M32.875,36h-1.562  H16.25h-1.375H9V4h5.875h2.562h14.25h1.188H39v9v2v16.938v2.438V36H32.875z' class='cc-devices-svg-icon'/></svg>";
// export const largeMobileSVG = "<svg style='enable-background:new 0 0 70 70;' version='1.1' viewBox='0 0 70 70' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><g id='Warstwa_2'><rect fill='transparent' height='56' id='XMLID_5_' width='38' x='16' y='7'/></g><g id='Warstwa_1'><path class='cc-devices-svg-icon' d='M54,7H16V6c0-3.3,2.7-6,6-6h26c3.3,0,6,2.7,6,6V7z' id='XMLID_1_'/><path class='cc-devices-svg-icon' d='M48,70H22c-3.3,0-6-2.7-6-6v-1h38v1C54,67.3,51.3,70,48,70z' id='XMLID_2_'/><rect class='cc-devices-svg-icon' height='56' id='XMLID_3_' width='1.4' x='16' y='7'/><rect class='cc-devices-svg-icon' height='56' id='XMLID_4_' width='1.4' x='52.6' y='7'/><path class='cc-devices-svg-icon' d='M47.9,4H22.1c-0.6,0-1-0.5-1-1v0c0-0.6,0.5-1,1-1h25.8c0.6,0,1,0.5,1,1v0   C48.9,3.6,48.5,4,47.9,4z' id='XMLID_6_'/></g><g id='Warstwa_3'/><g id='Warstwa_4'/></svg>";
// export const smallMobileSVG = "<svg enable-background='new 0 0 139 139' height='139px' id='Phone' version='1.1' viewBox='0 0 139 139' width='48px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><path d='M90.841,10.641H48.159c-7.252,0-13.133,5.88-13.133,13.133v94.12c0,7.252,5.88,13.133,13.133,13.133h42.682  c7.253,0,13.134-5.881,13.134-13.133v-94.12C103.975,16.521,98.094,10.641,90.841,10.641z M69.5,125.093  c-3.674,0-6.652-2.976-6.652-6.651s2.979-6.651,6.652-6.651c3.675,0,6.653,2.976,6.653,6.651S73.175,125.093,69.5,125.093z   M91.944,105.664H47.056V25.862c0-1.648,1.343-2.991,2.993-2.991h38.904c1.648,0,2.992,1.343,2.992,2.991V105.664z' class='cc-devices-svg-icon'/></svg>";
export const refreshIcon = <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#1E85FF"><path d="M481.33-158.67q-132 0-226.33-94-94.33-94-94.33-226V-511L86-436.33 41.33-481 194-633.67 346.67-481 302-436.33 227.33-511v32.33q0 104.67 74.5 179 74.5 74.34 179.5 74.34 28 0 53.67-5.34 25.67-5.33 49-16L632.67-198q-36.67 20.67-74.34 30-37.66 9.33-77 9.33ZM766.67-325 614-477.67 659.33-523l74 74v-29.67q0-104.66-74.5-179Q584.33-732 479.33-732q-28 0-53.66 5.67-25.67 5.66-49 15L328-760q36.67-20.67 74.33-29.67 37.67-9 77-9 132 0 226.34 94 94.33 94 94.33 226v31l74.67-74.66 44.66 44.66L766.67-325Z"/></svg>

//New SVG's for Device Type
const desktopSVG = `<svg viewBox="0 0 24 24" fill="currentColor"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="2" fill="none"/><line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" stroke-width="2"/><line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" stroke-width="2"/></svg>`;
const tabletLargeSVG = `<svg viewBox="0 0 24 24" fill="currentColor"><rect x="4" y="2" width="16" height="20" rx="2" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="12" cy="19" r="1" fill="currentColor"/></svg>`;
const tabletSVG = `<svg viewBox="0 0 24 24" fill="currentColor"><rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="12" cy="19" r="1" fill="currentColor"/></svg>`;
const mobileLargeSVG = `<svg viewBox="0 0 24 24" fill="currentColor"><rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="12" cy="19" r="1" fill="currentColor"/></svg>`;
const mobileSVG = `<svg viewBox="0 0 24 24" fill="currentColor"><rect x="8" y="2" width="8" height="20" rx="2" stroke="currentColor" stroke-width="2" fill="none"/><circle cx="12" cy="19" r="1" fill="currentColor"/></svg>`;

export const storefrontPopupDeviceTypes = {
    "desktop": "Desktop",
    "tabletlarge": "Large Tablet",
    "tablet": "Tablet",
    "mobilelarge": "Large Mobile",
    "mobile": "Mobile"
}

export const storefrontPopupStylesPriority = ["desktop", "tabletlarge", "tablet", "mobilelarge", "mobile"]

export const storefrontPopupClickActionCollection = [
    ["none", "None"],
    ["closepopup", "Close Popup"],
    ["submitlead", "Submit lead"],
    ["addtocartmoredetails", "Add To Cart / More Details"],
    ["subscribe", "Subscribe"]
]

export const storefrontPopupAlignCollection = [
    ["center", "Center"],
    ["left", "Left"],
    ["right", "Right"]
]

export const storefrontPopupFontStyleCollection = [
    ["italic", "Italic"],
    ["normal", "Normal"]
]

export const storefrontPopupFieldNameCollection = [
    ["emailAddress", "Email"],
    ["phoneNumber", "Phone"]
]

export const storefrontPopupLinkTargetCollection = [
    ["_blank", "New Tabs"],
    ["_self", "Same Tab"]
]

export const storefrontPopupBasicBlockElementList = ["text", "image", "button", "link", "coupon", "spacing", "input", "frequency"]

export const subAndSaveTrigger = "subAndSave"

export const subAndSaveEventName = "cc-popup-sub-and-save-event"

export const getStorefrontPopupBlockStyleValue = (elementData, deviceStyleKey = "desktopStyles", property) => {
    let value = elementData?.[deviceStyleKey]?.[property]
    if (value === null || value === undefined || (property === "backgroundImage" && value === "")) {
        const device = deviceStyleKey.replace("Styles", "")
        const currentIndex = storefrontPopupStylesPriority.indexOf(device);
        for (let i = currentIndex - 1; i >= 0; i--) {
            const styleValue = elementData?.[`${storefrontPopupStylesPriority[i]}Styles`]?.[property]
            if (styleValue !== null && styleValue !== undefined && (property === "backgroundImage" ? styleValue !== "" : true)) {
                return styleValue
            }
        }
        value = elementData?.["desktopStyles"]?.[property]
    }
    return value
}

export const getStorefrontPopupApplicableStyles = (currentDevice, obj, popupContainerStyles) => {
    const currentIndex = storefrontPopupStylesPriority.indexOf(currentDevice || "desktop")
    let finalStyles = {}
    for (let i = 0; i <= currentIndex; i++) {
        const key = `${storefrontPopupStylesPriority[i]}Styles`
        const styles = obj[key];
        if (styles && Object.keys(styles).length > 0) {
            finalStyles = {
                ...finalStyles,
                ...styles
            }
        }
    }
    if (popupContainerStyles) {
        finalStyles.backgroundImage = getStorefrontPopupBlockStyleValue(obj, `${currentDevice}Styles`, "backgroundImage")
    }
    return finalStyles
}

export const storefrontPopupDeviceTypesCollection = [
    {
        deviceName: "Desktop",
        device: "desktop",
        svg: desktopSVG
    },
    {
        deviceName: "Tablet Large",
        device: "tabletlarge",
        widthMedia: 992,
        svg: tabletLargeSVG
    },
    {
        deviceName: "Tablet",
        device: "tablet",
        widthMedia: 768,
        svg: tabletSVG
    },
    {
        deviceName: "Mobile Large",
        device: "mobilelarge",
        widthMedia: 600,
        svg: mobileLargeSVG
    },
    {
        deviceName: "Mobile",
        device: "mobile",
        widthMedia: 480,
        svg: mobileSVG
    }
]

export const getDeviceType = (width) => {
    if (width >= 992) return 'desktop';
    if (width >= 768) return 'tabletlarge';
    if (width >= 600) return 'tablet';
    if (width >= 480) return 'mobilelarge';
    return 'mobile';
};

export const storefrontPopupPages = (website) => {
    return [
        {
            slugConstant: "homepage_slug",
            slugValue: website["homepage_slug"],
            pageName: "Home Page"
        },
        {
            slugConstant: "product_page_slug",
            slugValue: website["product_page_slug"],
            pageName: "Product Page"
        },
        {
            slugConstant: "cart_page_slug",
            slugValue: website["cart_page_slug"],
            pageName: "Cart Page"
        },
        {
            slugConstant: "collection_page_slug",
            slugValue: website["collection_page_slug"],
            pageName: "Collection Page"
        }
    ]
}

export const generateUniqueIdForPopup = () => `popupItem-${Math.random().toString(36).substr(2, 9)}`;

export const getCleanedPixelValue = (value) => {
    return Number(value?.toString()?.replace("px", ""))
}

export const createLayoutObject = (key, customData = {}) => {
    const customDesktopStyles = customData.desktopStyles || {}
    const customTabletLargeStyles = customData.tabletlargeStyles || {}
    const customTabletStyles = customData.tabletStyles || {}
    const customMobileLargeStyles = customData.mobilelargeStyles || {}
    const customMobileStyles = customData.mobileStyles || {}
    const customDeviceDetails = customData.deviceType || {}
    delete customData["desktopStyles"]
    delete customData["tabletlargeStyles"]
    delete customData["tabletStyles"]
    delete customData["mobilelargeStyles"]
    delete customData["mobileStyles"]
    delete customData["deviceType"]
    const obj = {
        ...(storefrontPopupComponentDefaultDataMap[key] || {}),
        ...customData
    }
    obj.desktopStyles = {
        ...obj.desktopStyles,
        ...customDesktopStyles
    }
    obj.tabletlargeStyles = {
        ...obj.tabletlargeStyles,
        ...customTabletLargeStyles
    }
    obj.tabletStyles = {
        ...obj.tabletStyles,
        ...customTabletStyles
    }
    obj.mobilelargeStyles = {
        ...obj.mobilelargeStyles,
        ...customMobileLargeStyles
    }
    obj.mobileStyles = {
        ...obj.mobileStyles,
        ...customMobileStyles
    }
    obj.deviceType = {
        ...obj.deviceType,
        ...customDeviceDetails
    }
    return obj
}

export const storefrontPopupScrollOrOpenSettingsMap = {
    top: "top",
    builder: "builder"
}
